module.exports = __webpack_public_path__ + "media/2x/graduate-chart@2x-c46eab3e.png";